import React, {ChangeEvent, useEffect, useState, FocusEvent, FormEvent} from "react";
import styles from "./flyerDetailsRightPanel.module.scss";
import {useTypedSelector} from "../../../hooks/useTypeSelector";
import validator from "validator";
import {useDispatch} from "react-redux";
import GuiSelector from "../../../com/guiSelector/GuiSelector";
import moment from "moment";
import {
    ConversionDto, DisclaimerDto, EmailsObjectDto,
    ExampleCodeAndQtyDto, FlyerClassDto, FlyerDto, FlyerLanguageDto, FlyerPagination,
    FlyerStatus, FlyerStatusForSelect,
    FlyerTypeDto,
    GuiSettingsDto,
    LanguageCulture, UITextDto, URLSDto, UserDto
} from "../../../dtos";
import DatePicker from "react-datepicker";
import Moment from "react-moment";
import envManager from "../../../com/envManager/EnvManager";
import {OrangeButton} from "../../com/pagesTab/orangeBtn/OrangeButton";
import {
    getFlippingFlyer,
    saveFlyer,
} from "../../../store/actionCreators/flippingFlyerActionCreators";
import GuiSelectorItem from "../../../com/guiSelector/GuiSelectorItem";
import {ActionType} from "../../../store/actionTypes";
import {PageSpinner} from "../../com/pagesTab/pagesSpinner/spinner";
import {ReactComponent as CalendarIcon} from "../../../assets/flyerDetailsPopupAssets/calendar_icon.svg";
import {
    dispatchEventDataType,
    EVENT_DATA_TYPE_OPEN_PAGES_FLYER
} from "../../../globals/EventDispatcher";
import {
    someFlyerDetailsDataWasChangedInFlyerDetailsPopup
} from "../../../store/actionCreators/changeFlyerDetailsActionCreators";
import {
    Box,
    Button,
    Divider,
    Grid, Link,
    Typography,
} from "@mui/material";
import {createExampleCheckoutUrl, createExampleCheckoutUrlApp} from "../../../globals/globalFunctions";
import {CheckoutSettingPopup} from "../header/controls/right/settings/checkoutSettingsPopup/checkoutSettingPopup";
import _ from 'lodash';
import StatusPopup, {StatusPopupType} from "../../../com/statusPopup/StatusPopup";
import {getSettingsForPopup} from "../pages/getSetttingsForPopup";
import {
    AccountLocalAndTextSetting
} from "../header/controls/right/settings/accountLocalAndTextSettings/accountLocalAndTextSetting";
import {SimpleConfirmPopup} from "../../../com/simpleConfirmPopup/SimpleConfirmPopup";
import {SelectWithLabel} from "../../../com/selectWithLabel/selectWithLabel";
import {
    FlyerCheckoutSettingsForPopup
} from "../header/controls/right/settings/flyerCheckoutSettingForPopup/flyerCheckoutSettingsForPopup";
import {makeStyles} from "@mui/styles";
import {FlyersStateDto} from "../flyersCatalog/mainFlyersCatalog/flyersCatalog";
import ExpandCollapseBtn from "../../../com/expandCollapseBtn/expandCollapseBtn";
import {TextareaWithLabel} from "../../../com/textareaWithLabel/textareaWithLabel";
import {FLYER_PAGINATION_VARIANTS, FLYER_STATUSES, LANGUAGE_ENGLISH} from "../../../globals";
import {convertEmailsObjectToArray, getDate} from "../../../globals/globFunctions";
import {FlyerEmailSettings} from "../header/controls/right/settings/emailsSettingsPopup/flyerEmailSettings";

const useStyles = makeStyles(() => ({
    tabButton: {
        '&.MuiButton-root': {
            height: `38px`,
            display: `flex`,
            alignItems: `center`,
            justifyContent: `center`,
            textTransform: `capitalize`,
            width: `100%`,
            color: `black`,
            borderRadius: `0`,
            '&:hover': {
                backgroundColor: `#e4e4e480`,
            },
            '&.activeTab': {
                '&.MuiButton-root': {
                    width: `100%`,
                    borderRadius: `0`,
                    backgroundColor: `#ffffff`,
                    color: `initial`,
                    // borderTop: `2px solid #2A38BB`,
                    '& > .MuiTypography-root': {
                        color: `#2A38BB`,
                        fontWeight: `700`
                    },
                    '&:hover': {
                        backgroundColor: `#ffffff`,
                    }
                }
            },
        },
    },
    tabContentWrapper: {
        display: "flex",
        height: "100%"
    },
    tabs: {
        display: "flex",
        width: `100%`,
        minHeight: `36px`,
        // flexShrink: `0`,
        '& > .MuiButton-root': {
            width: `100%`,
            borderRadius: `0`,
            backgroundColor: `#D0E0F0`,
            color: `initial`,
            '&:hover': {
                backgroundColor: `#D0E0F0`,
            }
        }
    },
    illegalFlyersCountWrapper: {
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#ffffff",
        // borderLeft: "1px solid #888888",
    }
}))


export interface PopupEditData {
    isReadOnly: boolean;
    isNoEdit: boolean;
}

export interface Errors {
    captionErr: boolean;
    displayCationErr: boolean;
    noPagesErr: boolean;
    startDateErr: boolean;
    endDateErr: boolean;
    emailErr: boolean;
    phoneNumberErr: boolean;
    checkoutUrlSettingErr: boolean;
    checkoutBtnCaptionErr: boolean;
    phoneMessageErr: boolean;
    noCodeErr: boolean;
    // conversationUrlErr: boolean;
}

export interface PopupState {
    code: string;
    noPages: string;
    caption: string;
    description: string;
    // disclaimer: string;
    displayCaption: string;
    flyerClass: { value: string | undefined, label: string };
    startDate: any;
    endDate: any;
    createDate: any;
    modifiedDate: any;
    languageData: { flyLacRec: LanguageCulture; flyLacRecId: number };
    language: { value: string | undefined, label: string };
    gui: { flyGusRec: GuiSettingsDto; flygusRecId: number };
    currency: { value: string | undefined, label: string };
    email: string;
    phoneNumber: string;
    phoneMessage: string;
    conversationUrl: string;
    conversationUrlApp: string;
    radioType: {
        excel: boolean;
        text: boolean;
        isEmail: boolean;
        isUrl: boolean;
        isPhoneNumber: boolean;
    };

    // flyerStatus: { status: FlyerStatus; statusId: number };
    flyerStatus: FlyerStatusForSelect;
    flyerType: { value: string | undefined, label: string | undefined, id: number | undefined },
    // isSelectAccountCheckoutUrl: boolean;
    disclaimers?: null | DisclaimerDto,
    uiText?: null | UITextDto,
    urls?: null | URLSDto;
    flyPageLayoutPc: { value: string | undefined, label: string }
    contactDetails?: EmailsObjectDto
}

const initialFlyerState = {
    code: "",
    noPages: "",
    caption: "",
    description: "",
    // disclaimer: "",
    displayCaption: "",
    flyerClass: {
        value: "",
        label: "",
    },
    startDate: null,
    endDate: null,
    createDate: null,
    modifiedDate: null,
    languageData: {
        flyLacRec: LANGUAGE_ENGLISH,
        flyLacRecId: 0,
    },
    language: {
        value: "",
        label: ""
    },
    gui: {
        flygusRecId: -1,
        flyGusRec: {},
    },
    currency: {
        value: "",
        label: "",
    },
    email: "",
    phoneNumber: "",
    phoneMessage: "",
    conversationUrl: "",
    conversationUrlApp: "",
    radioType: {
        excel: true,
        text: false,
        isEmail: true,
        isUrl: false,
        isPhoneNumber: false,
    },
    // flyerStatus: {
    //     status: flyerDetailsState.flyFstRec,
    //     statusId: flyerDetailsState.flyFstRecId,
    // },
    flyerStatus: {
        value: '',
        label: '',
        status: {},
    },
    flyerType: {
        value: `2`,
        label: `XC Shopping Flyer`,
        id: 5,
    },
    // isSelectAccountCheckoutUrl: false,
    disclaimers: {},
    uiText: {},
    urls: {},
    flyPageLayoutPc: {value: "1", label: "Double Page, Horizontal Pagination"}
}

export interface GuiDto {
    gui: { flyGusRec: GuiSettingsDto; flygusRecId: number };
}

const guiInitialState = {
    gui: {
        flygusRecId: -1,
        flyGusRec: {},
    },
}

/*
interface Props {
    show: (a: boolean) => void;
    createNew: (a: boolean) => void;
    isNew: boolean;
    // isReadOny: boolean;
    isShow: boolean;
}
*/

interface Props {
    activeFlyers: FlyerDto[];
    isShouldCheckCurrentFlyerStateBeforeLeave?: boolean;
    setIsShouldCheckCurrentFlyerStateBeforeLeave?: (value: boolean) => void;
    flyersForHold: FlyerDto[];
    setCurrentState?: (state: FlyersStateDto) => void;
    currentState?: FlyersStateDto;
    rightPanelAnimationTimeInMs?: number;
    isPagesTab?: boolean;
}

export const FlyerDetailsRightPanel: React.FC<Props> = ({
                                                            activeFlyers,
                                                            isShouldCheckCurrentFlyerStateBeforeLeave = false,
                                                            setIsShouldCheckCurrentFlyerStateBeforeLeave,
                                                            flyersForHold,
                                                            setCurrentState,
                                                            currentState,
                                                            rightPanelAnimationTimeInMs,
                                                            isPagesTab = false
                                                        }) => {
    const dispatch = useDispatch();

    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    let flippingFlyerState = useTypedSelector((state) => state.flippingFlyer);
    const flyersState = useTypedSelector((state) => state.flyers);
    const guiSettingsState = useTypedSelector((state) => state.guiSettings);
    const changedStateForFlyer = useTypedSelector((state) => state.changedStateForFlyer);
    const conversionUrlSetting = useTypedSelector(state => state.conversionUrlSetting);
    const flyerClasses = useTypedSelector(state => state.flyerClasses);
    const {isShowRightPanel} = useTypedSelector((state) => state.toggleActionsForFlyers);
    const {accountEmailsState} = useTypedSelector((state) => state);
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);
    const isUserViewer = userDto.role !== 2 && userDto.role !== 3;
    const languages = flyersState?.languageCultures?.map((lang: FlyerLanguageDto) => {
        return {
            value: lang.code,
            label: lang.caption,
            language: {
                ...lang
            }
        }
    });

    const currencies = flyersState?.languageCultures?.map((lang: FlyerLanguageDto) => {
        return {
            value: lang.currencySymbol,
            label: `${lang.currencySymbol.trim()} ${lang.currencyAbbrv}`
        }
    });

    const getLanguage = (
        lang: LanguageCulture | undefined
    ): { value: string | undefined; label: string } => {
        return lang !== null ?
            {
                value: lang!.lacCode!,
                label: lang!.lacCaption!
            } : {
                value: "he-IL",
                label: `Hebrew`
            };
    };

    const getCurrency = (
        lang: LanguageCulture | undefined
    ): { value: string | undefined; label: string } => {
        return lang !== null ?
            {
                value: lang!.lacCurrencySymbol!,
                label: `${lang!.lacCurrencySymbol!.trim()} ${lang?.lacCurrencyAbbrv}`
            } : {
                value: "$",
                label: "$ USD"
            };
    };

    const getFlyerClass = (
        id: number | null
    ): { value: string | undefined; label: string } => {
        if (id !== null) {
            const currentFlyerClass = flyerClasses.flyerClasses.filter((flyerClass) => {
                if (flyerClass.id === id.toString()) {
                    return flyerClass;
                }
            })
            return currentFlyerClass.length ?
                {
                    value: currentFlyerClass[0].id.toString(),
                    label: currentFlyerClass[0].caption
                } : {
                    value: "-1",
                    label: "Unclassified"
                };
        } else {
            return {
                value: "-1",
                label: "Unclassified"
            }
        }
    };

    const getFlyerPagination = (
        id: number | null
    ): { value: string | undefined; label: string } => {
        if (id !== null) {
            const currentFlyerPaginationVariant = [...FLYER_PAGINATION_VARIANTS].filter((paginationVariant) => {
                if (Number(paginationVariant.value) === id) {
                    return paginationVariant;
                }
            })
            return {
                value: currentFlyerPaginationVariant[0].value?.toString() || "1",
                label: currentFlyerPaginationVariant[0].label || "Double Page, Horizontal Pagination"
            }
        } else {
            return {
                value: "",
                label: ``
            }
        }
    };

    const [isOpenPageScreen, changeOpenPageScreenStatus] = useState<boolean>(false);

    const [state, setState] = useState<PopupState>(initialFlyerState);
    const [gui, setGui] = useState<GuiDto>(guiInitialState);

    const [defaultState, setDefaultState] = useState<PopupState>(initialFlyerState);

    const [stateError, setErrorState] = useState<Errors>({
        captionErr: false,
        displayCationErr: false,
        noPagesErr: false,
        startDateErr: false,
        endDateErr: false,
        emailErr: false,
        phoneNumberErr: false,
        checkoutUrlSettingErr: false,
        checkoutBtnCaptionErr: false,
        phoneMessageErr: false,
        noCodeErr: false
        // conversationUrlErr: false,
    });
    const [isNoEdit, setNoEdit] = useState(false);
    const [isReadOnly, setReadOnly] = useState(false);
    // const [isFlyerPublished, setFlyerPublishedStatus] = useState(false);
    const isFlyerPublished = flyerDetailsState.flyFstRec.fstCaption === "Published";
    const [isChangedDataForCurrentFlyer, changeDataForCurrentFlyer] = useState<boolean>(changedStateForFlyer.isChangedFlyerData);
    // const [isSelectAccountCheckoutUrl, changeAccountUrlStatus] = useState<boolean>(false);
    const [checkoutUrlSetting, setCheckoutUrlSetting] = useState<ConversionDto>({});
    const [firstExample, setFirstExample] = useState<ExampleCodeAndQtyDto>({
        code: `8690637919381`,
        qty: `1`
    })
    const [secondExample, setSecondExample] = useState<ExampleCodeAndQtyDto>({
        code: `7290112492500`,
        qty: `1`
    })
    const [checkoutUrl, setCheckoutUrl] = useState<string>(``);
    const [checkoutUrlApp, setCheckoutUrlApp] = useState<string>(``);
    const [activeTabInUrlSetting, setActiveTabInUrlSetting] = useState<"pcTab" | "appTab">("pcTab");
    const [showCheckoutSettingsPopup, toggleCheckoutSettingsPopup] = useState(false);
    const [isMessagePopupShow, showMessagePopup] = useState<boolean>(false);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [flyerClassesState, setFlyerClassesState] = useState<any[]>([]);
    const [activeTabName, setActiveTab] = useState<string>(`details`);
    const [hoverTabName, setHoverTabName] = useState<string>(``);
    const [isShowConfirmExitPopup, setShowConfirmExitPopup] = useState<boolean>(false);
    const [isRequiredFieldsNotFilled, setIsRequiredFieldsNotFilled] = useState<boolean>(false);
    const [isCopied, setCopiedStatus] = useState<boolean>(false)
    const [isUrlCaptionUpdateByUser, setIsUrlCaptionUpdateByUser] = useState<boolean>(false)
    const [isExpired, setIsExpired] = useState<boolean>(false);
    const [inputValueForContactUsEmails, setInputValueForContactUsEmails] = useState<string>('');
    const [contactUsEmails, setContactUsEmails] = useState<string[]>([]);

    const mainLabelColumnNumber = 8;
    const inputColumnsNumber = 10;
    const secondaryLabelColumnNumber = 8;

    const stylesProperties = {
        activeTabName: activeTabName
    }

    const classes = useStyles(stylesProperties);


    // const [disclaimerDirection, setDisclaimerDirection] = useState<string>('ltr');
    const accountCheckoutSettings = {
        conversionUrlBase: conversionUrlSetting.data?.conversionUrlBase,
        conversionUrlBaseApp: conversionUrlSetting.data?.conversionUrlBaseApp,
        conversionEmail: conversionUrlSetting.data?.conversionEmail,
        interItemSeparator: conversionUrlSetting.data?.interItemSeparator,
        interItemSeparatorApp: conversionUrlSetting.data?.interItemSeparatorApp,
        intraItemSeparator: conversionUrlSetting.data?.intraItemSeparator,
        intraItemSeparatorApp: conversionUrlSetting.data?.intraItemSeparatorApp,
        itemCodePrefix: conversionUrlSetting.data?.itemCodePrefix,
        itemCodePrefixApp: conversionUrlSetting.data?.itemCodePrefixApp,
        itemListVarName: conversionUrlSetting.data?.itemListVarName,
        itemListVarNameApp: conversionUrlSetting.data?.itemListVarNameApp,
        itemOptionalParamValue: conversionUrlSetting.data?.itemOptionalParamValue,
        itemOptionalParamValueApp: conversionUrlSetting.data?.itemOptionalParamValueApp,
        optionalVars: conversionUrlSetting.data?.optionalVars,
        optionalVarsApp: conversionUrlSetting.data?.optionalVarsApp
    }
    // const [checkoutBtnDirection, setCheckoutBtnDirection] = useState<string>('ltr');

    useEffect(() => {

        const flyerClassesData = flyerClasses?.flyerClasses?.map((flyerClass: FlyerClassDto) => {
            return {
                value: flyerClass.id,
                label: flyerClass.caption
            }
        });
        setFlyerClassesState(flyerClassesData);

    }, [flyerClasses])

    useEffect(() => {
        if (isShouldCheckCurrentFlyerStateBeforeLeave) {
            onClosePromoDetailsPopup();
        }
    }, [isShouldCheckCurrentFlyerStateBeforeLeave, flyersForHold])

    useEffect(() => {
        setState({
            ...state,
            conversationUrl: checkoutUrl,
        })
        setErrorState({
            ...stateError,
            checkoutUrlSettingErr: !Boolean(checkoutUrl),
        })

    }, [checkoutUrl]);

    useEffect(() => {
        setState({
            ...state,
            conversationUrlApp: checkoutUrlApp,
        })
    }, [checkoutUrlApp]);

    useEffect(() => {
        changeDataForCurrentFlyer(changedStateForFlyer.isChangedFlyerData);
    }, [changedStateForFlyer.isChangedFlyerData])

    // useEffect(() => {
    // let checkoutUrlLink: string = conversationUrlResult();
    // let checkoutUrlLinkApp: string = conversationUrlResultApp();
    // setCheckoutUrl(checkoutUrlLink);
    // setCheckoutUrlApp(checkoutUrlLinkApp);
    // }, [state.isSelectAccountCheckoutUrl])

    useEffect(() => {
        if (flyerDetailsState.flyRecId === flippingFlyerState.flyerDto?.flyRecId) {
            const urlSettings = {
                conversionUrlBase: flyerDetailsState?.conversion?.conversionUrlBase,
                conversionUrlBaseApp: flyerDetailsState?.conversion?.conversionUrlBaseApp,
                interItemSeparator: flyerDetailsState?.conversion?.interItemSeparator,
                interItemSeparatorApp: flyerDetailsState?.conversion?.interItemSeparatorApp,
                intraItemSeparator: flyerDetailsState?.conversion?.intraItemSeparator,
                intraItemSeparatorApp: flyerDetailsState?.conversion?.intraItemSeparatorApp,
                itemCodePrefix: flyerDetailsState?.conversion?.itemCodePrefix,
                itemCodePrefixApp: flyerDetailsState?.conversion?.itemCodePrefixApp,
                itemListVarName: flyerDetailsState?.conversion?.itemListVarName,
                itemListVarNameApp: flyerDetailsState?.conversion?.itemListVarNameApp,
                itemOptionalParamValue: flyerDetailsState?.conversion?.itemOptionalParamValue,
                itemOptionalParamValueApp: flyerDetailsState?.conversion?.itemOptionalParamValueApp,
                optionalVars: flyerDetailsState?.conversion?.optionalVars,
                optionalVarsApp: flyerDetailsState?.conversion?.optionalVarsApp,
                conversionType: flyerDetailsState?.conversion?.conversionType,
            }
            setCheckoutUrlSetting(urlSettings);

            let dataForFlyer = {
                code: flyerDetailsState.flyCode || "",
                noPages: flyerDetailsState.flyerPages.length.toString(),
                caption: flyerDetailsState.flyCaption,
                description: flyerDetailsState.flyDesc,
                displayCaption: flyerDetailsState.flyDisplayCaption,
                flyerClass: getFlyerClass(flyerDetailsState.flyFlyerClassId || null),
                startDate: getDate(flyerDetailsState.flyValidFromUtc),
                endDate: getDate(flyerDetailsState.flyValidToUtc),
                createDate: getDate(flyerDetailsState.flyCreatedUtc),
                modifiedDate: getDate(flyerDetailsState.flyModifiedUtc),
                languageData: {
                    flyLacRec: flyerDetailsState.flyLacRec,
                    flyLacRecId: flyerDetailsState.flyLacRecId,
                },
                language: getLanguage(flyerDetailsState.flyLacRec),
                currency: getCurrency(flyerDetailsState.flyLacRec),
                gui: {
                    flygusRecId: flyerDetailsState!.flygusRecId!,
                    flyGusRec: flyerDetailsState.flyGusRec!,
                },
                email: flyerDetailsState?.conversion?.conversionEmail ? flyerDetailsState?.conversion?.conversionEmail : '',
                phoneNumber: flyerDetailsState?.conversion?.conversionPhoneNo ? flyerDetailsState?.conversion?.conversionPhoneNo : '',
                phoneMessage: flyerDetailsState?.conversion?.conversionPhoneMessage ? flyerDetailsState?.conversion?.conversionPhoneMessage : '',
                conversationUrl: conversationUrlResult(flyerDetailsState?.conversion && flyerDetailsState?.conversion.conversionUrlBase ? flyerDetailsState?.conversion : {}),
                conversationUrlApp: conversationUrlResultApp(flyerDetailsState?.conversion && flyerDetailsState?.conversion.conversionUrlBaseApp ? flyerDetailsState?.conversion : {}),
                radioType: {
                    excel: true,
                    text: false,
                    isEmail: flyerDetailsState?.conversion?.conversionType === 0 || !flyerDetailsState?.conversion?.conversionType,
                    isUrl: flyerDetailsState?.conversion?.conversionType === 1,
                    isPhoneNumber: flyerDetailsState?.conversion?.conversionType === 3
                },
                flyerStatus: {
                    value: flyerDetailsState.flyFstRecId ? flyerDetailsState.flyFstRecId.toString() : '',
                    label: flyerDetailsState.flyFstRec.fstCaption,
                    status: flyerDetailsState.flyFstRec,
                },
                flyerType: {
                    value: flyerDetailsState.flyRecId !== 0 && flyerDetailsState.flyFltRec.fltCode ? flyerDetailsState.flyFltRec.fltCode.toString() : `2`,
                    label: flyerDetailsState.flyRecId !== 0 && flyerDetailsState.flyFltRec.fltCaption ? flyerDetailsState.flyFltRec.fltCaption.toString() : `XC Shopping Flyer`,
                    id: flyerDetailsState.flyRecId !== 0 && flyerDetailsState.flyFltRec.fltRecId ? flyerDetailsState.flyFltRec.fltRecId : 5,
                },
                // isSelectAccountCheckoutUrl: false,
                // isSelectAccountCheckoutUrl: !!(conversionUrlSetting?.data?.conversionUrlBase),
                disclaimers: {
                    flyerDisclaimer: flyerDetailsState?.disclaimers?.flyerDisclaimer ? flyerDetailsState?.disclaimers?.flyerDisclaimer : '',
                    listDisclaimer: flyerDetailsState?.disclaimers?.listDisclaimer ? flyerDetailsState?.disclaimers?.listDisclaimer : '',
                    isFlyerDisclaimer: Boolean(flyerDetailsState.disclaimers?.isFlyerDisclaimer),
                    isListDisclaimer: Boolean(flyerDetailsState.disclaimers?.isListDisclaimer)
                },
                uiText: {
                    goToCheckout: flyerDetailsState?.uiTexts?.goToCheckout ? flyerDetailsState?.uiTexts?.goToCheckout : '',
                    flyerDisclaimerPopupTitle: flyerDetailsState.uiTexts?.flyerDisclaimerPopupTitle ? flyerDetailsState.uiTexts?.flyerDisclaimerPopupTitle : ``,
                    quickTips: flyerDetailsState.uiTexts?.quickTips ? flyerDetailsState.uiTexts?.quickTips : ``,
                    isQuickTips: Boolean(flyerDetailsState.uiTexts?.isQuickTips)
                },
                urls: {
                    accountHomePageUrl: flyerDetailsState?.urls && flyerDetailsState?.urls.accountHomePageUrl
                        ? flyerDetailsState?.urls.accountHomePageUrl
                        : flyerDetailsState.flyAccRec?.accountSetting?.urls && flyerDetailsState.flyAccRec?.accountSetting?.urls.accountHomePageUrl
                            ? flyerDetailsState.flyAccRec?.accountSetting?.urls.accountHomePageUrl
                            : ``
                },
                flyPageLayoutPc: getFlyerPagination(flyerDetailsState.flyPageLayoutPc ? flyerDetailsState.flyPageLayoutPc : 1),
                contactDetails: flyerDetailsState.contactDetails
            }
            const emailsArray = convertEmailsObjectToArray(flyerDetailsState.contactDetails || {});
            setContactUsEmails(emailsArray);
            setIsUrlCaptionUpdateByUser(false);
            setDefaultState(dataForFlyer);
            setState(dataForFlyer);
            setActiveTab(`details`);
            const validUntil = getDate(flyerDetailsState.flyValidToUtc);
            if (validUntil) {
                setIsExpired(new Date() > validUntil);
            }
            const onlyHebrewPattern = new RegExp(/^[a-zA-Z0-9\u0590-\u05fe-_]+$/i);
            const onlyLetterAndNumbers = new RegExp(/^[a-zA-Z0-9_.-]*$/i);
            const onlyNumbers = new RegExp(/^[0-9]+$/i);
            const isValidCaption = onlyHebrewPattern.test(flyerDetailsState.flyCaption);
            const isValidCode = onlyNumbers.test(flyerDetailsState.flyCode);
            const captionErr = flyerDetailsState.flyCaption === "" ? true : !isValidCaption;
            const codeErr = flyerDetailsState.flyCode === ""
                ? true
                : !isValidCode;
            const displayCationErr =
                flyerDetailsState.flyDisplayCaption === ""
                    ? true
                    : flyerDetailsState.flyDisplayCaption === "";
            const noPagesErr = flyerDetailsState.flyerPages.length.toString() === ""
                ? true
                : !validator.isNumeric(flyerDetailsState.flyerPages.length.toString());
            const startDateErr = flyerDetailsState.flyValidFromUtc
                ? getDate(flyerDetailsState.flyValidFromUtc) === null
                : getDate(moment(new Date()).toDate()) === null;
            const endDateErr = flyerDetailsState.flyValidToUtc
                ? getDate(flyerDetailsState.flyValidToUtc) === null
                : getDate(moment(new Date()).endOf('year').toDate()) === null;
            const emailErr =
                !Boolean(dataForFlyer.email)
                    ? true
                    : !validator.isEmail(dataForFlyer.email);
            const phoneNumberErr =
                !Boolean(flyerDetailsState?.conversion?.conversionPhoneNo)
                    ? true
                    : !validator.isMobilePhone(flyerDetailsState?.conversion?.conversionPhoneNo ? flyerDetailsState?.conversion?.conversionPhoneNo : '');
            const phoneMessageErr =
                !Boolean(dataForFlyer.phoneMessage)
                    ? true
                    : dataForFlyer.phoneMessage === "";
            const checkoutUrlSettingErr = !Boolean(flyerDetailsState?.conversion?.conversionUrlBase) && flyerDetailsState?.conversion?.conversionType !== 0;
            // const conversationErr = !validator.isURL(
            //     flyerDetailsState.flyConversionEmail
            // );
            let checkoutBtnCaptionErr = flyerDetailsState.uiTexts?.goToCheckout === ""
                ? true
                : flyerDetailsState.uiTexts?.goToCheckout === "";

            setErrorState({
                captionErr: captionErr,
                displayCationErr: displayCationErr,
                noPagesErr: noPagesErr,
                startDateErr: startDateErr,
                endDateErr: endDateErr,
                emailErr: emailErr,
                phoneNumberErr: phoneNumberErr,
                phoneMessageErr: phoneMessageErr,
                checkoutUrlSettingErr: checkoutUrlSettingErr,
                checkoutBtnCaptionErr: checkoutBtnCaptionErr,
                noCodeErr: codeErr
                // conversationUrlErr: conversationErr,
            });
            setNoEdit(
                window.location.pathname.indexOf("archive") > -1 ||
                window.location.pathname.indexOf("trash") > -1
            );
            setReadOnly(true);
        }
    }, [flyerDetailsState.flyRecId, flippingFlyerState.flyerDto]);

    useEffect(() => {
        setGui({
            gui: {
                flygusRecId: flyerDetailsState!.flygusRecId!,
                flyGusRec: flyerDetailsState.flyGusRec!,
            },
        })
    }, [flyerDetailsState.flyGusRec])

    useEffect(() => {
        let checkoutUrlLink: string = conversationUrlResult();
        setCheckoutUrl(checkoutUrlLink);
        let checkoutUrlLinkApp: string = conversationUrlResultApp();
        setCheckoutUrlApp(checkoutUrlLinkApp);
    }, [checkoutUrlSetting]);

    useEffect(() => {
        const defaultStateString = JSON.stringify(defaultState);
        const changedState = JSON.stringify(state);
        let isStateWasChanged = defaultStateString !== changedState;
        dispatch(someFlyerDetailsDataWasChangedInFlyerDetailsPopup(isStateWasChanged));
    }, [state, defaultState]);

    useEffect(() => {
        if (
            flippingFlyerState.type === ActionType.GET_FLIPPING_FLYER_START ||
            flippingFlyerState.type === ActionType.POST_FLIPPING_FLYER_START
        ) {
            setState(initialFlyerState);
            setDefaultState(initialFlyerState);
            setCheckoutUrlSetting({});
            setCheckoutUrl("");
            setCheckoutUrlApp("");
            setLoading(flippingFlyerState.loading);
        } else if (
            flippingFlyerState.type === ActionType.GET_FLIPPING_FLYER_SUCCESS
        ) {
            setLoading(flippingFlyerState.loading);
        } else if (
            flippingFlyerState.type === ActionType.POST_FLIPPING_FLYER_SUCCESS
        ) {
            setLoading(flippingFlyerState.loading);
            // dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_OPEN_FLYER_INFO_POPUP, {
            //     isOpen: true,
            //     isChangedData: false
            // });
            // dispatch(toggleFlyerDetailsPopup(false));
            // if (isNew && !isShow) {
            //     dispatch(updateFlyersState(flyersState));
            //     dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_DISABLE_TABS, true);
            // }
            if (flyerDetailsState.flyRecId !== 0) {
                dispatch(getFlippingFlyer(flyerDetailsState.flyRecId));
            }

        }
    }, [flippingFlyerState.type]);


    useEffect(() => {
        if (isOpenPageScreen) {
            dispatchEventDataType<string | undefined>(
                EVENT_DATA_TYPE_OPEN_PAGES_FLYER,
                {
                    isOpen: true,
                    flyerCaption: state.caption
                }
            );
        }
    }, [state.caption, isOpenPageScreen]);

    const addEmailToContactUsEmails = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        e.stopPropagation();
        if (!checkValidValueForEmailsInput() || contactUsEmails.length >= 4 || isAlreadyExist() || !inputValueForContactUsEmails) {
            return;
        }
        const newEmailArray = [
            ...contactUsEmails,
            inputValueForContactUsEmails
        ];
        setContactUsEmails(newEmailArray);
        setInputValueForContactUsEmails("");
        setState({
            ...state,
            contactDetails: {
                emailAddress1: newEmailArray[0] || "",
                emailAddress2: newEmailArray[1] || "",
                emailAddress3: newEmailArray[2] || "",
                emailAddress4: newEmailArray[3] || "",
            }
        })
    }

    const removeEmailFromContactUsEmails = (email: string) => {
        const newEmails = contactUsEmails.filter(emailFromState => emailFromState !== email);
        setContactUsEmails(newEmails);
        setState({
            ...state,
            contactDetails: {
                emailAddress1: newEmails[0] || "",
                emailAddress2: newEmails[1] || "",
                emailAddress3: newEmails[2] || "",
                emailAddress4: newEmails[3] || "",
            }
        })
    }

    const isAlreadyExist = (): boolean => {
        return contactUsEmails.some(email => email === inputValueForContactUsEmails);
    };


    const checkValidValueForEmailsInput = (): boolean => {
        return validator.isEmail(inputValueForContactUsEmails) || inputValueForContactUsEmails === '';
    };

    const onChangeInputEmailForContactUsEmails = (event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
        const value = event.target.value;
        setInputValueForContactUsEmails(value);
    }

    const filteredFlyerTypes = flyersState?.flyerTypes?.filter((flyerType: FlyerTypeDto) => {
        if (flyerType.code === 2 || flyerType.code === 3 || flyerType.code === 1) {
            return flyerType;
        }
    });
    const flyerTypes = filteredFlyerTypes?.map((flyerType: FlyerTypeDto) => {
        return {
            value: flyerType.code.toString(),
            label: flyerType.caption.toString(),
            id: flyerType.id,
        };
    });
    const flyerStatuses = [...FLYER_STATUSES]?.map((flyerStatus: FlyerStatus) => {
        return {
            value: flyerStatus.fstRecId?.toString(),
            label: flyerStatus.fstCaption?.toString(),
            status: flyerStatus,
        };
    });

    const flyerPaginationOptions = [...FLYER_PAGINATION_VARIANTS]?.map((flyerStatus: FlyerPagination) => {
        return {
            value: flyerStatus.value?.toString(),
            label: flyerStatus.label?.toString(),
        };
    });

    const conversationUrlResult = (flyerCheckoutSettings?: ConversionDto): string => {
        let checkoutUrlLink: string = ``;
        // if (state.isSelectAccountCheckoutUrl && conversionUrlSetting.data) {
        //     checkoutUrlLink = createExampleCheckoutUrl(conversionUrlSetting.data, firstExample, secondExample);
        // } else {
        if (!_.isEmpty(checkoutUrlSetting) && _.isEmpty(flyerCheckoutSettings)) {
            if (checkoutUrlSetting.conversionUrlBase) {
                checkoutUrlLink = createExampleCheckoutUrl(checkoutUrlSetting, firstExample, secondExample);
            }
        } else if (!_.isEmpty(flyerCheckoutSettings)) {
            checkoutUrlLink = createExampleCheckoutUrl(flyerCheckoutSettings, firstExample, secondExample);
        }
        // }
        return checkoutUrlLink;
    }

    const conversationUrlResultApp = (flyerCheckoutSettings?: ConversionDto): string => {
        let checkoutUrlLinkApp: string = ``;
        // if (state.isSelectAccountCheckoutUrl && conversionUrlSetting.data?.conversionUrlBaseApp) {
        //     checkoutUrlLinkApp = createExampleCheckoutUrlApp(conversionUrlSetting.data, firstExample, secondExample);
        // } else {
        if (!_.isEmpty(checkoutUrlSetting) && _.isEmpty(flyerCheckoutSettings)) {
            if (checkoutUrlSetting.conversionUrlBaseApp) {
                checkoutUrlLinkApp = createExampleCheckoutUrlApp(checkoutUrlSetting, firstExample, secondExample);
            }
        } else if (!_.isEmpty(flyerCheckoutSettings)) {
            checkoutUrlLinkApp = createExampleCheckoutUrlApp(flyerCheckoutSettings, firstExample, secondExample);
        }
        // }
        return checkoutUrlLinkApp;
    }

    const changeLang = (item: any) => {
        setState({
            ...state,
            language: {
                value: item.value,
                label: item.label
            },
            languageData: {
                flyLacRec: {
                    ...item.language,
                    lacRecId: item.language.id,
                    lacCode: item.language.code,
                    lacCaption: item.language.caption,
                    lacDir: item.language.dir,
                    lacCurrencySymbol: item.language.currencySymbol
                },
                flyLacRecId: item.language.id!,
            },
            currency: {
                value: item.language.currencySymbol,
                label: `${item.language.currencySymbol.trim()} ${item.language.currencyAbbrv}`
            },
        });
        console.log(`Option selected:`, item);
    };

    const changeFlyerType = (item: any) => {
        setState({
            ...state,
            flyerType: item,
        });
        console.log(`Option selected:`, item);
    };

    const changeCurrency = (item: any) => {
        setState({
            ...state,
            currency: item.value,
        });
        console.log(`Option selected:`, item);
    };

    const changeFlyerClass = (item: any) => {
        setState({
            ...state,
            flyerClass: item,
        });
        console.log(`Option selected:`, item);
    };

    const onFulfilmentTypeChanged = (type: string) => {
        let newState = {
            excel: type === "Excel",
            text: type === "Text",
        };
        setState({
            ...state,
            radioType: {
                ...state.radioType,
                ...newState,
            },
        });
    };

    const onFulfilmentListChanges = (type: string) => {
        let newState = {
            isEmail: type === "Email",
            isUrl: type === "URL",
            isPhoneNumber: type === "PhoneNumber"
        };
        setState({
            ...state,
            radioType: {
                ...state.radioType,
                ...newState,
            },
        });
    };

    const onPCFlyerPagesOrientationChange = (paginationOption: FlyerPagination) => {
        setState({
            ...state,
            flyPageLayoutPc: paginationOption,
        });

    };

    const onFlyerStatusChanged = (status: FlyerStatusForSelect) => {
        setState({
            ...state,
            flyerStatus: {
                status: status.status,
                value: status.value,
                label: status.label
            },
        });
    };

    const getFlyerAppUrlElement = () => {
        try {
            let flyerAppAddress = envManager.flyerAppAddress;

            let currentFlyerStatus = flyerDetailsState.flyFstRec;
            let statusCaption = currentFlyerStatus!.fstCaption?.toLowerCase();

            let appUrl = "";

            if (statusCaption?.includes("edit")) {
                appUrl = flyerAppAddress =
                    envManager.getFlyerAppAddressWithEnvPrefix("dev");
            } else if (statusCaption?.includes("qa")) {
                appUrl = envManager.getFlyerAppAddressWithEnvPrefix("qa");
            } else if (statusCaption?.includes("published")) {
                appUrl = envManager.getFlyerAppAddressWithEnvPrefix("");
            }

            //
            if (appUrl.length !== 0 && flyerDetailsState.flyRecId) {
                let accountName = flyerDetailsState.flyAccRec?.accCaption;
                let flyerName = flyerDetailsState.flyCaption;
                appUrl += `${flyerDetailsState.flyFltRec?.fltCode === 1 ? "flipbook" : "flyer"}/${accountName}/${flyerName}`;
            }

            if (statusCaption?.includes("inactive")) {
                appUrl = "--";
                return appUrl;
            }

            // Any way if the current flyer has no job code (RecId) => no flyer app address to show
            if (!flyerDetailsState.flyRecId) {
                appUrl = "--";

                return appUrl;
            } else {
                appUrl = `${appUrl}`;

                return (
                    <div>
                        {isNoEdit && flyerDetailsState.flyFstRec.fstCaption !== "Published" ? <Typography>
                            Inactive Flyer
                        </Typography> : <a
                            className="label_indicator url_indicator"
                            target="_blank"
                            href={appUrl}
                        >
                            {appUrl}
                        </a>
                        }
                    </div>
                );
            }
        } catch (e) {
            return "--";
        }
    };

    const onChangeCaption = (e: ChangeEvent<HTMLTextAreaElement>) => {
        const value = e.target.value.trimStart().replace(/\s\s+/g, ' ');
        if (value === "") {
            setErrorState({
                ...stateError,
                captionErr: true,
            });
        } else {
            const onlyHebrewPattern = new RegExp(/^[a-zA-Z0-9\u0590-\u05fe-_]+$/i);
            const isValid = onlyHebrewPattern.test(value);
            setErrorState({
                ...stateError,
                captionErr: !isValid,
            });
        }
        setIsUrlCaptionUpdateByUser(true);
        setState({
            ...state,
            caption: value,
        });
    };

    const onChangeCode = (e: ChangeEvent<HTMLTextAreaElement>) => {
        if (e.target.value === "") {
            setErrorState({
                ...stateError,
                noCodeErr: true,
            });
        } else {
            const onlyLetterAndNumbers = new RegExp(/^[a-zA-Z0-9_.-]*$/i);
            const onlyNumbers = new RegExp(/^[0-9]+$/i);
            const isValid = onlyNumbers.test(e.target.value);
            setErrorState({
                ...stateError,
                noCodeErr: !isValid,
            });
        }
        setState({
            ...state,
            code: e.target.value,
        });
    };

    const onChangePagesNo = (e: ChangeEvent<HTMLTextAreaElement>) => {
        const isNumber = validator.isNumeric(e.target.value, {no_symbols: true});
        if (isNumber) {
            let amount = Number(e.target.value);

            if (isNaN(amount) || amount < 0 || e.target.value[0] === "0") {
            } else {
                amount > 100
                    ? setState({...state, noPages: "100"})
                    : setState({...state, noPages: e.target.value});
                setErrorState({
                    ...stateError,
                    noPagesErr: false,
                });
            }
        } else if (!isNumber && e.target.value === "") {
            setState({...state, noPages: e.target.value});
            setErrorState({
                ...stateError,
                noPagesErr: true,
            });
        }
    };

    const onChangeDisplayCaption = (e: ChangeEvent<HTMLTextAreaElement>) => {
        const value = e.target.value;
        value.trimStart().replace(/\s\s+/g, ' ');
        setState({
            ...state,
            displayCaption: value.trimStart().replace(/\s\s+/g, ' '),
            caption: isUrlCaptionUpdateByUser ? state.caption : value.trim().replace(/\s\s+/g, ' ').replace(/ /g, '-')
        });

        const onlyHebrewPattern = new RegExp(/^[a-zA-Z0-9\u0590-\u05fe-_]+$/i);
        const isValid = onlyHebrewPattern.test(value.trim().replace(/\s\s+/g, ' ').replace(/ /g, '-'));

        setErrorState({
            ...stateError,
            captionErr: isUrlCaptionUpdateByUser ? stateError.captionErr : e.target.value === "" || !isValid,
            displayCationErr: e.target.value === "",
        });
    };


    const onChangeEmail = (e: ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        e.stopPropagation();
        const isEmail = validator.isEmail(e.target.value);
        setErrorState({
            ...stateError,
            emailErr: !isEmail,
        });
        setState({
            ...state,
            email: e.target.value,
        });
    };

    const onChangePhoneMessage = (e: ChangeEvent<HTMLTextAreaElement>) => {
        setErrorState({
            ...stateError,
            phoneMessageErr: e.target.value === "",
        });
        setState({
            ...state,
            phoneMessage: e.target.value,
        });
    };

    const copyDataFromAccountUsingPropertyName = (propertyName: string) => {
        if (conversionUrlSetting.data) {
            switch (propertyName) {
                case "valuesForWhatsApp": {
                    const {conversionPhoneNo, conversionPhoneMessage} = conversionUrlSetting.data;
                    if (!conversionPhoneNo && !conversionPhoneMessage) {
                        showMessagePopup(true);
                        break;
                    }
                    const isMobilePhone = validator.isMobilePhone(conversionPhoneNo || "");
                    setErrorState({
                        ...stateError,
                        phoneMessageErr: !conversionPhoneMessage,
                        phoneNumberErr: !isMobilePhone
                    });
                    setState({
                        ...state,
                        phoneMessage: conversionPhoneMessage || '',
                        phoneNumber: conversionPhoneNo || ''
                    });
                    break;
                }
                case "valuesForEmail": {
                    const {conversionEmail} = conversionUrlSetting.data;
                    if (!conversionEmail) {
                        showMessagePopup(true);
                        break;
                    }
                    const isEmail = validator.isEmail(conversionEmail || "");
                    setErrorState({
                        ...stateError,
                        emailErr: !isEmail,
                    });
                    setState({
                        ...state,
                        email: conversionEmail || "",
                    });
                    break;
                }
                case "urlLinkForPc":
                case "urlLinkForApp": {
                    changeCheckoutForCheckoutUrlForAccount(propertyName);
                    break;
                }
                case "valuesForContactUsEmails": {
                    const emailsArray = convertEmailsObjectToArray(accountEmailsState.emails || {});
                    setContactUsEmails(emailsArray);
                    setState({
                        ...state,
                        contactDetails: {
                            emailAddress1: emailsArray[0] || "",
                            emailAddress2: emailsArray[1] || "",
                            emailAddress3: emailsArray[2] || "",
                            emailAddress4: emailsArray[3] || "",
                        }
                    })
                    break;
                }
                default: {
                    break
                }
            }
        }
    }

    const onChangeCheckoutBtnText = (e: ChangeEvent<HTMLTextAreaElement>) => {

        setErrorState({
            ...stateError,
            checkoutBtnCaptionErr: e.target.value === "",
        });
        setState({
            ...state,
            uiText: {
                goToCheckout: e.target.value
            },
        });
    };

    const onChangePhoneNumber = (phoneNumber: string) => {
        const isMobilePhoneEmail = validator.isMobilePhone(phoneNumber);
        setErrorState({
            ...stateError,
            phoneNumberErr: !isMobilePhoneEmail,
        });
        setState({
            ...state,
            phoneNumber: phoneNumber,
        });
    };

    /*
        const onChangeCheckoutForCheckoutUrlForAccount = (e: ChangeEvent<HTMLInputElement>) => {
            if (!Boolean(conversionUrlSetting.data?.conversionUrlBase)) {
                showMessagePopup(true);
                return;
            }
            const isChecked = e.target.checked;
            setState({
                ...state,
                isSelectAccountCheckoutUrl: isChecked
            });
            if (isChecked && conversionUrlSetting.data) {
                const accountCheckoutUrl = createExampleCheckoutUrl(conversionUrlSetting.data, firstExample, secondExample);
                const accountCheckoutUrlApp = Boolean(conversionUrlSetting.data.conversionUrlBaseApp && conversionUrlSetting.data.itemListVarNameApp) ? createExampleCheckoutUrlApp(conversionUrlSetting.data, firstExample, secondExample) : '';
                if (checkoutUrl !== accountCheckoutUrl && flyerDetailsState.flyRecId) {
                    setCheckoutUrl(accountCheckoutUrl);
                    // dispatch(saveConversionUrlSettings({
                    //     ...accountCheckoutSettings,
                    //     conversionType: flyerDetailsState?.conversion?.conversionType
                    // }, false, flyerDetailsState.flyRecId));
                }
                if (checkoutUrlApp !== accountCheckoutUrlApp && flyerDetailsState.flyRecId) {
                    setCheckoutUrlApp(accountCheckoutUrlApp);
                    // dispatch(saveConversionUrlSettings({
                    //     ...accountCheckoutSettings,
                    //     conversionType: flyerDetailsState?.conversion?.conversionType
                    // }, false, flyerDetailsState.flyRecId));
                }
            } else if (!isChecked && !_.isEmpty(checkoutUrlSetting)) {
                const flyerCheckoutUrl = createExampleCheckoutUrl(checkoutUrlSetting, firstExample, secondExample);
                const flyerCheckoutUrlApp = createExampleCheckoutUrlApp(checkoutUrlSetting, firstExample, secondExample);
                if (checkoutUrl !== flyerCheckoutUrl && flyerDetailsState.flyRecId) {
                    setCheckoutUrl(flyerCheckoutUrl);
                    // dispatch(saveConversionUrlSettings(checkoutUrlSetting, false, flyerDetailsState.flyRecId));
                }
                if (checkoutUrlApp !== flyerCheckoutUrlApp && flyerDetailsState.flyRecId) {
                    setCheckoutUrlApp(flyerCheckoutUrl);
                    // dispatch(saveConversionUrlSettings(checkoutUrlSetting, false, flyerDetailsState.flyRecId));
                }
            }
        };
    */

    const changeCheckoutForCheckoutUrlForAccount = (targetCheckoutSettingFromAccountName: string) => {
        if (targetCheckoutSettingFromAccountName === 'urlLinkForPc' && conversionUrlSetting.data) {
            if (!Boolean(conversionUrlSetting.data?.conversionUrlBase)) {
                showMessagePopup(true);
                return;
            }
            const accountCheckoutUrl = createExampleCheckoutUrl(conversionUrlSetting.data, firstExample, secondExample);
            if (checkoutUrl !== accountCheckoutUrl && flyerDetailsState.flyRecId) {
                setCheckoutUrl(accountCheckoutUrl);
                const {
                    conversionUrlBase,
                    interItemSeparator,
                    intraItemSeparator,
                    itemCodePrefix,
                    itemListVarName,
                    itemOptionalParamValue,
                    optionalVars
                } = conversionUrlSetting.data;
                setCheckoutUrlSetting(
                    {
                        ...checkoutUrlSetting,
                        conversionUrlBase,
                        interItemSeparator,
                        intraItemSeparator,
                        itemCodePrefix,
                        itemListVarName,
                        itemOptionalParamValue,
                        optionalVars
                    }
                )
            }
            return;
        }
        if (targetCheckoutSettingFromAccountName === 'urlLinkForApp' && conversionUrlSetting.data) {
            if (!Boolean(conversionUrlSetting.data?.conversionUrlBaseApp)) {
                showMessagePopup(true);
                return;
            }
            const accountCheckoutUrlApp = Boolean(conversionUrlSetting.data.conversionUrlBaseApp && conversionUrlSetting.data.itemListVarNameApp) ? createExampleCheckoutUrlApp(conversionUrlSetting.data, firstExample, secondExample) : '';
            if (checkoutUrlApp !== accountCheckoutUrlApp && flyerDetailsState.flyRecId) {
                setCheckoutUrlApp(accountCheckoutUrlApp);
                const {
                    conversionUrlBaseApp,
                    interItemSeparatorApp,
                    intraItemSeparatorApp,
                    itemCodePrefixApp,
                    itemListVarNameApp,
                    itemOptionalParamValueApp,
                    optionalVarsApp
                } = conversionUrlSetting.data;
                setCheckoutUrlSetting(
                    {
                        ...checkoutUrlSetting,
                        conversionUrlBaseApp,
                        interItemSeparatorApp,
                        intraItemSeparatorApp,
                        itemCodePrefixApp,
                        itemListVarNameApp,
                        itemOptionalParamValueApp,
                        optionalVarsApp
                    }
                )
            }
            return;
        }
    };

    const onCheckInput = (e: FocusEvent<HTMLInputElement>) => {
        if (e.target.value === "") {
            setState({...state, noPages: "1"});
            setErrorState({
                ...stateError,
                noPagesErr: false,
            });
        }
    };

    const onChangeGui = (guiSetting: GuiSettingsDto) => {
        setState({
            ...state,
            gui: {
                flygusRecId: guiSetting.gusRecId!,
                flyGusRec: guiSetting,
            },
        });
        setGui({
            gui: {
                flygusRecId: guiSetting.gusRecId!,
                flyGusRec: guiSetting,
            },
        });
    };

    const editCheckoutUrl = (value: "pcTab" | "appTab") => {
        setActiveTabInUrlSetting(value);
        toggleCheckoutSettingsPopup(true);
    }

    const onHidePopup = () => {
        toggleCheckoutSettingsPopup(false);
    }

    const deleteCheckoutUrl = () => {
        setCheckoutUrlSetting({
            ...checkoutUrlSetting,
            conversionUrlBase: null,
            itemListVarName: null,
            itemCodePrefix: null,
            interItemSeparator: null,
            itemOptionalParamValue: null,
            intraItemSeparator: null,
            optionalVars: []
        });
    }
    const deleteCheckoutUrlApp = () => {
        setCheckoutUrlSetting({
            ...checkoutUrlSetting,
            conversionUrlBaseApp: null,
            itemListVarNameApp: null,
            itemCodePrefixApp: null,
            interItemSeparatorApp: null,
            itemOptionalParamValueApp: null,
            intraItemSeparatorApp: null,
            optionalVarsApp: []
        });
    }

    const onSaveFlyer = (toPages: boolean) => {
        // const currentFlyerCheckoutSettings = state.isSelectAccountCheckoutUrl ? accountCheckoutSettings : checkoutUrlSetting;
        const newState = {
            ...flyerDetailsState,
            flyCode: state.code,
            flyCaption: state.caption,
            flyDisplayCaption: state.displayCaption,
            flyDesc: state.description,
            flyFstRec: state.flyerStatus.status!,
            flyFstRecId: Number(state.flyerStatus.value),
            flyGusRec: gui.gui.flyGusRec,
            flyFlyerClassId: Number(state.flyerClass.value) !== -1 ? Number(state.flyerClass.value) : null,
            flygusRecId: gui.gui.flygusRecId,
            flyLacRec: {
                ...state.languageData.flyLacRec,
                lacCurrencySymbol: state.currency.value,
            },
            flyFltRec: {
                ...flyerDetailsState.flyFltRec,
                fltRecId: state.flyerType.id
            },
            conversion: {
                ...checkoutUrlSetting,
                conversionEmail: state.email,
                conversionPhoneNo: state.phoneNumber,
                conversionPhoneMessage: state.phoneMessage,
                conversionType: state.radioType.isUrl ? 1 : state.radioType.isPhoneNumber ? 3 : 0,
            },
            disclaimers: {
                ...flyerDetailsState.disclaimers,
                listDisclaimer: state.disclaimers?.listDisclaimer,
                flyerDisclaimer: state.disclaimers?.flyerDisclaimer,
                isFlyerDisclaimer: state.disclaimers?.isFlyerDisclaimer,
                isListDisclaimer: state.disclaimers?.isListDisclaimer
            },
            uiTexts: {
                ...flyerDetailsState.uiTexts,
                goToCheckout: state.uiText?.goToCheckout,
                flyerDisclaimerPopupTitle: state.uiText?.flyerDisclaimerPopupTitle,
                quickTips: state.uiText?.quickTips,
                isQuickTips: state.uiText?.isQuickTips
            },
            urls: {
                accountHomePageUrl: state.urls?.accountHomePageUrl
            },
            flyPageLayoutPc: Number(state.flyPageLayoutPc.value) || 1,
            contactDetails: state.contactDetails
        };
        if (state.startDate) {
            newState.flyValidFromUtc = new Date(
                state.startDate?.getTime() -
                state.startDate?.getTimezoneOffset() * 60000
            ).toJSON();
        }
        if (state.endDate) {
            newState.flyValidToUtc = new Date(
                state.endDate?.getTime() - state.endDate?.getTimezoneOffset() * 60000
            ).toJSON();
        }
        if (state.createDate) {
            newState.flyCreatedUtc = new Date(
                state.createDate?.getTime() -
                state.createDate?.getTimezoneOffset() * 60000
            ).toJSON();
        }
        if (state.modifiedDate) {
            newState.flyModifiedUtc = new Date(
                state.modifiedDate?.getTime() -
                state.modifiedDate?.getTimezoneOffset() * 60000
            ).toJSON();
        }

        delete newState.noPages;
        dispatch(saveFlyer(newState, flippingFlyerState, flyersState, false));
        dispatch(someFlyerDetailsDataWasChangedInFlyerDetailsPopup(false));
        if (toPages) {
            changeOpenPageScreenStatus(toPages);
        }
        if (setIsShouldCheckCurrentFlyerStateBeforeLeave) {
            setIsShouldCheckCurrentFlyerStateBeforeLeave(false);
        }
    };

    const onClickOnTab = (event: React.MouseEvent<HTMLButtonElement>) => {
        const target = event.currentTarget as HTMLButtonElement;
        const name = target.name;
        if (name !== activeTabName) {
            setActiveTab(name);
        }
    }

    const onClosePromoDetailsPopup = () => {
        if (isChangedDataForCurrentFlyer && !isReadOnly) {
            setShowConfirmExitPopup(true);
        } else {
            dispatch(someFlyerDetailsDataWasChangedInFlyerDetailsPopup(false));
        }
    }

    const checkerBeforeSavePromoDetails = () => {
        if (
            stateError.endDateErr ||
            stateError.noCodeErr ||
            (stateError.emailErr && state.radioType.isEmail) ||
            (stateError.phoneNumberErr && state.radioType.isPhoneNumber) ||
            // (state.radioType.isUrl &&
            //     stateError.conversationUrlErr) ||
            stateError.startDateErr ||
            !validator.isURL(state.urls?.accountHomePageUrl ? state.urls?.accountHomePageUrl : ``) ||
            stateError.checkoutBtnCaptionErr ||
            stateError.phoneMessageErr ||
            stateError.captionErr ||
            (stateError.checkoutUrlSettingErr && state.radioType.isUrl) ||
            stateError.displayCationErr ||
            stateError.noPagesErr ||
            isReadOnly ||
            !isChangedDataForCurrentFlyer

        ) {
            setIsRequiredFieldsNotFilled(true);
        } else {
            onSaveFlyer(false);
        }
    };


    const onSaveBtnClick = (goToPages: boolean) => {
        if (
            stateError.endDateErr ||
            stateError.noCodeErr ||
            (stateError.emailErr && state.radioType.isEmail) ||
            (stateError.phoneNumberErr && state.radioType.isPhoneNumber) ||
            (stateError.phoneMessageErr && state.radioType.isPhoneNumber) ||
            // (state.radioType.isUrl &&
            //     stateError.conversationUrlErr) ||
            stateError.startDateErr ||
            stateError.checkoutBtnCaptionErr ||
            stateError.captionErr ||
            stateError.displayCationErr ||
            !validator.isURL(state.urls?.accountHomePageUrl ? state.urls?.accountHomePageUrl : ``) ||
            (stateError.checkoutUrlSettingErr && state.radioType.isUrl) ||
            stateError.noPagesErr ||
            isReadOnly ||
            !isChangedDataForCurrentFlyer
        ) {
        } else {
            onSaveFlyer(goToPages);
        }
    }


    const onCloseWithoutSaving = () => {
        dispatch(someFlyerDetailsDataWasChangedInFlyerDetailsPopup(false));
        if (setIsShouldCheckCurrentFlyerStateBeforeLeave) {
            setIsShouldCheckCurrentFlyerStateBeforeLeave(false);
        }
        if (setCurrentState && currentState) {
            setCurrentState({
                ...currentState,
                activeFlyers: [...flyersForHold],
                lastActivatedFlyer: flyersForHold.length ? flyersForHold[0] : {}
            })
        }
    };

    const confirmErrorPopup = () => {
        setIsRequiredFieldsNotFilled(false);
    }

    const onCopyUrl = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        navigator.clipboard.writeText(`${envManager.flyerAppAddress}/${flyerDetailsState.flyFltRec?.fltCode === 1 ? "flipbook" : "flyer"}/${userDto.company}/${state.caption?.trim()}`)
            .then(() => {
                setCopiedStatus(true)
                setTimeout(() => {
                    setCopiedStatus(false)
                }, 2500)
            })
            .catch((error) => {
                console.log(error);
            })
    }

    const settings = {
        typeStatus: 0,
        title: '',
        subTitle: '',
        messages: [],
        modalName: `checkoutAccountSettingNotExist`,
    };

    let settingsForPopup = getSettingsForPopup(settings);

    const isDisabledOption = isReadOnly || isFlyerPublished;

    return (
        <>
            <ExpandCollapseBtn setLoading={setLoading} animationTime={rightPanelAnimationTimeInMs || 0}/>
            <Box className={styles.flyer_info_popup}>
                {
                    !isShowRightPanel ?
                        <></> :
                        isShowRightPanel && (activeFlyers.length === 0 || activeFlyers.length > 1) ?
                            <Box
                                className={classes.illegalFlyersCountWrapper}
                            >
                                <Typography>
                                    {activeFlyers.length === 0 ? "No flyer selected" : "Please select only one Flyer"}
                                </Typography>
                            </Box>
                            :
                            <>
                                {isLoading
                                    ?
                                    <div className={styles.loading}>
                                        <PageSpinner/>
                                    </div>
                                    :
                                    <>
                                        {
                                            activeFlyers.length === 1 &&
                                            <>
                                                {/*<div className={`${styles.header}`}>*/}
                                                {/*    <Typography color={"#000000"} fontWeight={700}>*/}
                                                {/*        Flyer Details {flyerDetailsState.flyCaption}*/}
                                                {/*    </Typography>*/}
                                                {/*</div>*/}

                                                <Box className={classes.tabs} mb={`16px`}>
                                                    <Button
                                                        onMouseEnter={(event) => {
                                                            setHoverTabName(event.currentTarget.name)
                                                        }}
                                                        onMouseLeave={() => {
                                                            setHoverTabName(``)
                                                        }}
                                                        disableTouchRipple
                                                        disableRipple
                                                        name={`details`}
                                                        onClick={onClickOnTab}
                                                        className={`${classes.tabButton} ${activeTabName === `details` ? `activeTab` : ``}`}
                                                    >
                                                        <Typography
                                                            fontSize={`14px`}
                                                            fontWeight={`900`}
                                                        >
                                                            Details
                                                        </Typography>
                                                    </Button>
                                                    <Divider orientation="vertical" color={`#D8E1FF`}/>
                                                    <Button
                                                        onMouseEnter={(event) => {
                                                            setHoverTabName(event.currentTarget.name)
                                                        }}
                                                        onMouseLeave={() => {
                                                            setHoverTabName(``)
                                                        }}
                                                        disableTouchRipple
                                                        disableRipple
                                                        name={`startup`}
                                                        onClick={onClickOnTab}
                                                        className={`${classes.tabButton} ${activeTabName === `startup` ? `activeTab` : ``}`}
                                                    >
                                                        <Typography
                                                            fontSize={`14px`}
                                                            fontWeight={`900`}
                                                        >
                                                            Startup
                                                        </Typography>
                                                    </Button>
                                                    <Divider orientation="vertical" color={`#D8E1FF`}/>
                                                    <Button
                                                        onMouseEnter={(event) => {
                                                            setHoverTabName(event.currentTarget.name)
                                                        }}
                                                        onMouseLeave={() => {
                                                            setHoverTabName(``)
                                                        }}
                                                        disableTouchRipple
                                                        disableRipple
                                                        name={`checkout`}
                                                        onClick={onClickOnTab}
                                                        className={`${classes.tabButton} ${activeTabName === `checkout` ? `activeTab` : ``}`}
                                                    >
                                                        <Typography
                                                            fontSize={`14px`}
                                                            fontWeight={`900`}
                                                        >
                                                            Checkout
                                                        </Typography>
                                                    </Button>
                                                    <Divider orientation="vertical" color={`#D8E1FF`}/>
                                                    <Button
                                                        onMouseEnter={(event) => {
                                                            setHoverTabName(event.currentTarget.name)
                                                        }}
                                                        onMouseLeave={() => {
                                                            setHoverTabName(``)
                                                        }}
                                                        disableTouchRipple
                                                        disableRipple
                                                        name={`emails`}
                                                        onClick={onClickOnTab}
                                                        className={`${classes.tabButton} ${activeTabName === `emails` ? `activeTab` : ``}`}
                                                    >
                                                        <Typography
                                                            fontSize={`14px`}
                                                            fontWeight={`900`}
                                                        >
                                                            Email Settings
                                                        </Typography>
                                                    </Button>
                                                </Box>

                                                <Box sx={{
                                                    padding: `5px 15px 10px`,
                                                    flex: `1 1 auto`,
                                                    display: `flex`,
                                                    flexFlow: `column`,
                                                    overflow: "auto"
                                                }}>
                                                    {
                                                        activeTabName === `details` &&
                                                        <Box className={classes.tabContentWrapper}>
                                                            <div
                                                                className={`${styles.content_wrapper} col-sm-12 ${
                                                                    styles.without_space
                                                                } ${isReadOnly ? styles.read_only_content : ""}`}
                                                            >

                                                                {(isNoEdit && !isFlyerPublished) && (
                                                                    <div
                                                                        className={`${styles.section_with_columns} row col-sm-12 ${styles.without_space}`}
                                                                    >
                                                                        To edit Job Details, first "Restore" this Flyer
                                                                        from
                                                                        the
                                                                        previous screen
                                                                    </div>
                                                                )
                                                                }
                                                                <Grid container alignItems={`center`}
                                                                      columns={36}>
                                                                    <TextareaWithLabel
                                                                        labelGridSizeNumber={mainLabelColumnNumber}
                                                                        inputGridSizeNumber={inputColumnsNumber}
                                                                        valueForInput={flyerDetailsState.flyRecId?.toString() || ""}
                                                                        labelCaption={'Global Flyer ID:'}
                                                                        isBold={true}
                                                                        readonly={true}
                                                                        labelAlign={"end"}
                                                                        fontSize={"16"}
                                                                    />
                                                                    <TextareaWithLabel
                                                                        labelGridSizeNumber={secondaryLabelColumnNumber}
                                                                        inputGridSizeNumber={inputColumnsNumber}
                                                                        labelCaption={"Account's JobCode:"}
                                                                        valueForInput={state.code}
                                                                        readonly={isDisabledOption}
                                                                        onChangeInput={onChangeCode}
                                                                        labelAlign={"end"}
                                                                        isRequired={true}
                                                                        isNotValid={stateError.noCodeErr}
                                                                        maxLength={10}
                                                                    />
                                                                </Grid>

                                                                <Grid container alignItems={`center`}
                                                                      columns={36}>
                                                                    <SelectWithLabel
                                                                        labelGridSizeNumber={mainLabelColumnNumber}
                                                                        selectGridSizeNumber={inputColumnsNumber}
                                                                        valueForSelect={isExpired ? {
                                                                            label: "Expired"
                                                                        } : state.flyerStatus}
                                                                        onChangeSelect={onFlyerStatusChanged}
                                                                        selectArray={flyerStatuses}
                                                                        labelCaption={'Flyer\'s Status:'}
                                                                        isBold={true}
                                                                        readonly={isReadOnly || isExpired}
                                                                        labelAlign={"end"}
                                                                    />
                                                                    <TextareaWithLabel
                                                                        labelGridSizeNumber={secondaryLabelColumnNumber}
                                                                        inputGridSizeNumber={inputColumnsNumber}
                                                                        labelCaption={"Pages:"}
                                                                        isNotValid={stateError.noPagesErr}
                                                                        valueForInput={state.noPages}
                                                                        readonly={true}
                                                                        onChangeInput={onChangePagesNo}
                                                                        labelAlign={"end"}
                                                                    />
                                                                </Grid>

                                                                <Grid container alignItems={`center`}
                                                                      columns={36}>
                                                                    <TextareaWithLabel
                                                                        labelGridSizeNumber={mainLabelColumnNumber}
                                                                        valueForInput={state.displayCaption}
                                                                        labelCaption={'Display Caption:'}
                                                                        isBold={true}
                                                                        readonly={isDisabledOption}
                                                                        maxLength={100}
                                                                        onChangeInput={onChangeDisplayCaption}
                                                                        isNotValid={stateError.displayCationErr}
                                                                        isRequired={true}
                                                                        labelAlign={"end"}
                                                                    />
                                                                </Grid>

                                                                <Grid container alignItems={`center`}
                                                                      columns={36}>
                                                                    <TextareaWithLabel
                                                                        labelGridSizeNumber={mainLabelColumnNumber}
                                                                        valueForInput={state.caption}
                                                                        labelCaption={'URL Caption:'}
                                                                        isBold={true}
                                                                        readonly={isDisabledOption}
                                                                        maxLength={100}
                                                                        onChangeInput={onChangeCaption}
                                                                        isNotValid={stateError.captionErr}
                                                                        isRequired={true}
                                                                        labelAlign={"end"}
                                                                    />
                                                                </Grid>
                                                                <Grid container alignItems={`center`}
                                                                    // sx={{
                                                                    //     minHeight: "34px"
                                                                    // }}
                                                                      columns={36}>
                                                                    <Grid item xs={mainLabelColumnNumber}>
                                                                        <Typography
                                                                            sx={{
                                                                                fontSize: `14px`,
                                                                                fontWeight: `bold`,
                                                                                fontFamily: `roboto`,
                                                                                marginRight: `12px`
                                                                            }}
                                                                            textTransform={`capitalize`}
                                                                            textAlign={'end'}>
                                                                            Full URL caption:
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid item xs>
                                                                        <Box
                                                                            sx={{
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'space-between',
                                                                                columnGap: "4px"
                                                                            }}
                                                                        >
                                                                            <Link
                                                                                underline="always"
                                                                                rel="noopener noreferrer"
                                                                                href={`${envManager.flyerAppAddress}/${flyerDetailsState.flyFltRec?.fltCode === 1 ? "flipbook" : "flyer"}/${userDto.company}/${state.caption?.trim()}`}
                                                                                target={"_blank"}
                                                                                fontSize={"14px"}
                                                                                sx={{
                                                                                    wordBreak: `break-all`,
                                                                                    color: "#000000",
                                                                                    textDecorationColor: "#000000",
                                                                                    "&:hover": {
                                                                                        color: "#000000",
                                                                                        textDecorationColor: "#000000"
                                                                                    }

                                                                                }}>
                                                                                {`${envManager.flyerAppAddress}/${flyerDetailsState.flyFltRec?.fltCode === 1 ? "flipbook" : "flyer"}/${userDto.company}/${state.caption?.trim()}`}
                                                                            </Link>
                                                                            <Box
                                                                                sx={{
                                                                                    display: "flex",
                                                                                    justifyContent: "flex-start"
                                                                                }}
                                                                            >
                                                                                <Button
                                                                                    disabled={isCopied || state.caption?.trim() !== defaultState.caption?.trim()}
                                                                                    onClick={onCopyUrl}
                                                                                    sx={{
                                                                                        minWidth: "50px",
                                                                                        // color: `#FFFFFF`,
                                                                                        borderRadius: `2px`,
                                                                                        "&:disabled": {
                                                                                            opacity: "0.5"
                                                                                        }
                                                                                    }}
                                                                                >
                                                                                    <Typography color={"#E5870E"}
                                                                                                fontSize={"14px"}
                                                                                                fontWeight={900}>
                                                                                        {isCopied ? "Copied" : "Copy"}
                                                                                    </Typography>
                                                                                </Button>

                                                                            </Box>
                                                                        </Box>
                                                                    </Grid>
                                                                </Grid>

                                                                <Grid container alignItems={`center`}
                                                                      columns={36}>
                                                                    <SelectWithLabel
                                                                        labelGridSizeNumber={mainLabelColumnNumber}
                                                                        selectGridSizeNumber={inputColumnsNumber}
                                                                        valueForSelect={state.flyerType}
                                                                        onChangeSelect={changeFlyerType}
                                                                        selectArray={flyerTypes}
                                                                        labelCaption={'Flyer type:'}
                                                                        isBold={true}
                                                                        readonly={isDisabledOption}
                                                                        labelAlign={"end"}
                                                                    />
                                                                    <SelectWithLabel
                                                                        labelGridSizeNumber={secondaryLabelColumnNumber}
                                                                        selectGridSizeNumber={inputColumnsNumber}
                                                                        valueForSelect={state.flyerClass}
                                                                        onChangeSelect={changeFlyerClass}
                                                                        selectArray={flyerClassesState}
                                                                        labelCaption={'Sort Class:'}
                                                                        labelAlign={`end`}
                                                                        isBold={true}
                                                                        readonly={isDisabledOption}
                                                                        // readonly={readonly ? readonly : false}
                                                                    />
                                                                </Grid>

                                                                <Grid container alignItems={`center`}
                                                                      columns={36}>
                                                                    <SelectWithLabel
                                                                        labelGridSizeNumber={mainLabelColumnNumber}
                                                                        selectGridSizeNumber={inputColumnsNumber}
                                                                        valueForSelect={state.language}
                                                                        onChangeSelect={changeLang}
                                                                        selectArray={languages}
                                                                        labelCaption={'language:'}
                                                                        isBold={true}
                                                                        readonly={isDisabledOption}
                                                                        labelAlign={"end"}
                                                                    />
                                                                    <SelectWithLabel
                                                                        labelGridSizeNumber={secondaryLabelColumnNumber}
                                                                        selectGridSizeNumber={inputColumnsNumber}
                                                                        valueForSelect={state.currency}
                                                                        onChangeSelect={changeCurrency}
                                                                        selectArray={currencies}
                                                                        labelCaption={'currency:'}
                                                                        labelAlign={`end`}
                                                                        isBold={true}
                                                                        isRequired={true}
                                                                        readonly={true}
                                                                        // readonly={readonly ? readonly : false}
                                                                    />
                                                                </Grid>

                                                                <Grid container alignItems={`center`}
                                                                    // sx={{
                                                                    //     minHeight: "34px"
                                                                    // }}
                                                                      columns={36}>
                                                                    <Grid item xs={mainLabelColumnNumber}>
                                                                        <Typography
                                                                            sx={{
                                                                                fontSize: `14px`,
                                                                                fontWeight: `bold`,
                                                                                fontFamily: `roboto`,
                                                                                marginRight: `12px`
                                                                            }}
                                                                            textTransform={`capitalize`}
                                                                            textAlign={'end'}>
                                                                            Brand:
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid item xs position={"relative"}>
                                                                        {(isReadOnly || isFlyerPublished) ? (
                                                                            <GuiSelectorItem
                                                                                guiSettings={flyerDetailsState.flyGusRec!}/>
                                                                        ) : (
                                                                            <GuiSelector
                                                                                items={guiSettingsState.guiSettings}
                                                                                selectedItem={gui.gui.flyGusRec}
                                                                                isNew={true}
                                                                                onChange={onChangeGui}
                                                                            />
                                                                        )}
                                                                    </Grid>
                                                                </Grid>

                                                                <Grid container alignItems={`center`}
                                                                      columns={36}>
                                                                    <SelectWithLabel
                                                                        labelGridSizeNumber={mainLabelColumnNumber}
                                                                        valueForSelect={state.flyPageLayoutPc}
                                                                        onChangeSelect={onPCFlyerPagesOrientationChange}
                                                                        selectArray={flyerPaginationOptions}
                                                                        labelCaption={'Paging in PC:'}
                                                                        isBold={true}
                                                                        readonly={isDisabledOption}
                                                                        labelAlign={"end"}
                                                                        withDisabledSomeOptions={Number(state.noPages) === 1}
                                                                        disabledOptions={Number(state.noPages) === 1 ? ["1", "2"] : []}
                                                                    />
                                                                </Grid>

                                                                <Grid container alignItems={`center`}
                                                                    // sx={{
                                                                    //     minHeight: "34px"
                                                                    // }}
                                                                      columns={36}>
                                                                    <Grid item xs={mainLabelColumnNumber}>
                                                                        <Typography
                                                                            sx={{
                                                                                fontSize: `14px`,
                                                                                fontWeight: `bold`,
                                                                                fontFamily: `roboto`,
                                                                                marginRight: `12px`
                                                                            }}
                                                                            textTransform={`capitalize`}
                                                                            textAlign={'end'}>
                                                                            Start Date:
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid item xs={inputColumnsNumber}
                                                                          position={"relative"}>
                                                                        {(isDisabledOption) ? (
                                                                            <>
                                                                                {state.startDate ? (
                                                                                    <Moment
                                                                                        date={state.startDate}
                                                                                        format="D MMM YYYY"
                                                                                        withTitle
                                                                                    />
                                                                                ) : (
                                                                                    "--"
                                                                                )}
                                                                            </>
                                                                        ) : (
                                                                            <div
                                                                                className={`${styles.date_picker_wrapper}`}
                                                                            >
                                                                                <DatePicker
                                                                                    dateFormat={`dd.MM.yyyy`}
                                                                                    popperProps={{
                                                                                        positionFixed: true, // use this to make the popper position: fixed
                                                                                    }}
                                                                                    popperClassName={styles.date_picker}
                                                                                    className={`${stateError.startDateErr ? styles.error_signal : ''}`}
                                                                                    selected={state.startDate}
                                                                                    onChange={(date: Date) => {
                                                                                        setState({
                                                                                            ...state,
                                                                                            startDate: date,
                                                                                        });
                                                                                        setErrorState({
                                                                                            ...stateError,
                                                                                            startDateErr: !date,
                                                                                        });
                                                                                    }}
                                                                                    maxDate={moment(state.endDate).subtract(1, "d").toDate()}
                                                                                    popperPlacement="bottom"
                                                                                />
                                                                                <div className={styles.calendar}>
                                                                                    <CalendarIcon/>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </Grid>
                                                                    <Grid item xs={secondaryLabelColumnNumber}>
                                                                        <Typography
                                                                            sx={{
                                                                                fontSize: `14px`,
                                                                                fontWeight: `bold`,
                                                                                fontFamily: `roboto`,
                                                                                marginRight: `12px`
                                                                            }}
                                                                            textTransform={`capitalize`}
                                                                            textAlign={'end'}>
                                                                            End Date:
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid item xs={inputColumnsNumber}
                                                                          position={"relative"}>
                                                                        {(isDisabledOption) ? (
                                                                            <>
                                                                                {state.endDate ? (
                                                                                    <Moment
                                                                                        date={state.endDate}
                                                                                        format="D MMM YYYY"
                                                                                        withTitle
                                                                                    />
                                                                                ) : (
                                                                                    "--"
                                                                                )}
                                                                            </>
                                                                        ) : (
                                                                            <div
                                                                                className={`${styles.date_picker_wrapper}`}
                                                                            >
                                                                                <DatePicker
                                                                                    dateFormat={`dd.MM.yyyy`}
                                                                                    popperProps={{
                                                                                        positionFixed: true, // use this to make the popper position: fixed
                                                                                    }}
                                                                                    popperClassName={styles.date_picker}
                                                                                    className={`${styles.date_picker_end} ${stateError.startDateErr ? styles.error_signal : ''}`}
                                                                                    selected={state.endDate}
                                                                                    onChange={(date: Date) => {
                                                                                        setState({
                                                                                            ...state,
                                                                                            endDate: date,
                                                                                        });
                                                                                        setIsExpired(new Date() > date);
                                                                                        setErrorState({
                                                                                            ...stateError,
                                                                                            endDateErr: !date,
                                                                                        });
                                                                                    }}
                                                                                    minDate={moment(state.startDate).add(1, "d").toDate()}
                                                                                    popperPlacement="bottom"
                                                                                />
                                                                                <div className={styles.calendar}>
                                                                                    <CalendarIcon/>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </Grid>
                                                                </Grid>

                                                                <Grid container alignItems={`center`}
                                                                    // sx={{
                                                                    //     minHeight: "34px"
                                                                    // }}
                                                                      columns={36}>
                                                                    <Grid item xs={mainLabelColumnNumber}>
                                                                        <Typography
                                                                            sx={{
                                                                                fontSize: `14px`,
                                                                                fontWeight: `bold`,
                                                                                fontFamily: `roboto`,
                                                                                marginRight: `12px`
                                                                            }}
                                                                            textTransform={`capitalize`}
                                                                            textAlign={'end'}>
                                                                            Created Date:
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid item xs={inputColumnsNumber}
                                                                          position={"relative"}>
                                                                        {state.createDate ? (
                                                                            <Moment
                                                                                date={state.createDate}
                                                                                format="D MMM YYYY"
                                                                                withTitle
                                                                            />
                                                                        ) : (
                                                                            "--"
                                                                        )}
                                                                    </Grid>
                                                                    <Grid item xs={secondaryLabelColumnNumber}>
                                                                        <Typography
                                                                            sx={{
                                                                                fontSize: `14px`,
                                                                                fontWeight: `bold`,
                                                                                fontFamily: `roboto`,
                                                                                marginRight: `12px`
                                                                            }}
                                                                            textTransform={`capitalize`}
                                                                            textAlign={'end'}>
                                                                            Modified Date:
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid item xs={inputColumnsNumber}
                                                                          position={"relative"}>
                                                                        {state.modifiedDate ? (
                                                                            <Moment
                                                                                date={state.modifiedDate}
                                                                                format="D MMM YYYY"
                                                                                withTitle
                                                                            />
                                                                        ) : (
                                                                            "--"
                                                                        )}
                                                                    </Grid>
                                                                </Grid>

                                                            </div>
                                                        </Box>

                                                    }

                                                    {
                                                        activeTabName === `startup` &&
                                                        <Box className={classes.tabContentWrapper}>
                                                            <AccountLocalAndTextSetting
                                                                settingForAccount={false}
                                                                readonly={isReadOnly}
                                                                data={state}
                                                                changeData={setState}
                                                                isNew={false}
                                                            />
                                                        </Box>
                                                    }

                                                    {
                                                        activeTabName === `checkout` &&
                                                        <Box className={classes.tabContentWrapper}>
                                                            <FlyerCheckoutSettingsForPopup
                                                                settingForAccount={false}
                                                                readonly={isReadOnly}
                                                                data={state}
                                                                changeData={setState}
                                                                isNew={true}
                                                                onFulfilmentListChanges={onFulfilmentListChanges}
                                                                isFlyerPublished={isFlyerPublished}
                                                                // onChangeCheckoutForCheckoutUrlForAccount={onChangeCheckoutForCheckoutUrlForAccount}
                                                                checkoutUrl={checkoutUrl}
                                                                checkoutUrlApp={checkoutUrlApp}
                                                                editCheckoutUrl={editCheckoutUrl}
                                                                deleteCheckoutUrl={deleteCheckoutUrl}
                                                                deleteCheckoutUrlApp={deleteCheckoutUrlApp}
                                                                onChangeEmail={onChangeEmail}
                                                                stateError={stateError}
                                                                onFulfilmentTypeChanged={onFulfilmentTypeChanged}
                                                                onChangePhoneNumber={onChangePhoneNumber}
                                                                onChangePhoneMessage={onChangePhoneMessage}
                                                                onChangeCheckoutBtnText={onChangeCheckoutBtnText}
                                                                copyDataFromAccountUsingPropertyName={copyDataFromAccountUsingPropertyName}
                                                            />
                                                        </Box>
                                                    }
                                                    {
                                                        activeTabName === `emails` &&
                                                        <Box className={classes.tabContentWrapper}>
                                                            <FlyerEmailSettings
                                                                readonly={isReadOnly}
                                                                isFlyerPublished={isFlyerPublished}
                                                                copyDataFromAccountUsingPropertyName={copyDataFromAccountUsingPropertyName}
                                                                isValidEmailFromInputContactUsEmails={checkValidValueForEmailsInput()}
                                                                inputValueForContactUsEmails={inputValueForContactUsEmails}
                                                                contactUsEmails={contactUsEmails}
                                                                addItemToContactUsEmails={addEmailToContactUsEmails}
                                                                removeEmailFromContactUsEmails={removeEmailFromContactUsEmails}
                                                                onChangeInputEmailForContactUsEmails={onChangeInputEmailForContactUsEmails}
                                                            />
                                                        </Box>
                                                    }

                                                </Box>
                                                <Box
                                                    sx={{
                                                        padding: `8px 15px 12px`,
                                                    }}
                                                >
                                                    {!isReadOnly ? (
                                                        <div className={styles.buttons_wrapper}>
                                                            <div
                                                                className={`${
                                                                    stateError.endDateErr ||
                                                                    stateError.noCodeErr ||
                                                                    (stateError.emailErr && state.radioType.isEmail) ||
                                                                    (stateError.phoneNumberErr && state.radioType.isPhoneNumber) ||
                                                                    (stateError.phoneMessageErr && state.radioType.isPhoneNumber) ||
                                                                    // (state.radioType.isUrl && stateError.conversationUrlErr) ||
                                                                    stateError.startDateErr ||
                                                                    stateError.captionErr ||
                                                                    stateError.checkoutBtnCaptionErr ||
                                                                    stateError.displayCationErr ||
                                                                    stateError.noPagesErr ||
                                                                    (stateError.checkoutUrlSettingErr && state.radioType.isUrl) ||
                                                                    !validator.isURL(state.urls?.accountHomePageUrl ? state.urls?.accountHomePageUrl : ``) ||
                                                                    isReadOnly ||
                                                                    !isChangedDataForCurrentFlyer
                                                                        ? styles.disabled
                                                                        : ""
                                                                }`}
                                                                onClick={() => {
                                                                    onSaveBtnClick(false)
                                                                }}
                                                            >
                                                                <OrangeButton buttonName="Save"
                                                                              backgroundColor={"#014780"}/>
                                                            </div>
                                                            {
                                                                !isPagesTab &&
                                                                <div
                                                                    className={`${
                                                                        stateError.endDateErr ||
                                                                        stateError.noCodeErr ||
                                                                        (stateError.emailErr && state.radioType.isEmail) ||
                                                                        (stateError.phoneNumberErr && state.radioType.isPhoneNumber) ||
                                                                        (stateError.phoneMessageErr && state.radioType.isPhoneNumber) ||
                                                                        // (state.radioType.isUrl && stateError.conversationUrlErr) ||
                                                                        stateError.startDateErr ||
                                                                        stateError.checkoutBtnCaptionErr ||
                                                                        stateError.captionErr ||
                                                                        !validator.isURL(state.urls?.accountHomePageUrl ? state.urls?.accountHomePageUrl : ``) ||
                                                                        stateError.displayCationErr ||
                                                                        (stateError.checkoutUrlSettingErr && state.radioType.isUrl) ||
                                                                        stateError.noPagesErr ||
                                                                        isReadOnly ||
                                                                        !isChangedDataForCurrentFlyer
                                                                            ? styles.disabled
                                                                            : ""
                                                                    }`}
                                                                    onClick={() => {
                                                                        onSaveBtnClick(true)
                                                                    }}
                                                                >
                                                                    <OrangeButton buttonName="Save & Continue to Pages"
                                                                                  backgroundColor={"#014780"}/>
                                                                </div>
                                                            }
                                                        </div>
                                                    ) : (
                                                        <div className={styles.buttons_wrapper}>
                                                            <div
                                                                className={`${isNoEdit || isUserViewer ? styles.disabled : ""}`}
                                                                onClick={() => {
                                                                    if (!isNoEdit && !isUserViewer) {
                                                                        setReadOnly(false);
                                                                    }
                                                                }}
                                                            >
                                                                <OrangeButton buttonName="Edit"
                                                                              backgroundColor={"#014780"}/>
                                                            </div>
                                                        </div>
                                                    )}
                                                </Box>
                                            </>
                                        }
                                    </>
                                }
                            </>
                }
            </Box>
            <CheckoutSettingPopup
                activeTabInUrlSetting={activeTabInUrlSetting}
                isShow={showCheckoutSettingsPopup}
                closePopup={onHidePopup}
                settingForAccount={false}
                setCheckoutUrlSetting={setCheckoutUrlSetting}
                setFirstExample={setFirstExample}
                setSecondExample={setSecondExample}
                checkoutUrlDataForFlyer={checkoutUrlSetting}
                accountCheckoutSettings={accountCheckoutSettings}
            />
            <StatusPopup
                settings={settingsForPopup}
                type={StatusPopupType.INFO}
                title={'INFO'}
                subTitle={''}
                messages={[settingsForPopup.messages]}
                show={isMessagePopupShow}
                handleClose={() => showMessagePopup(false)}
            />

            {isShowConfirmExitPopup && (
                <SimpleConfirmPopup
                    onClose={setShowConfirmExitPopup}
                    contentText={`Save changes?`}
                    onConfirm={checkerBeforeSavePromoDetails}
                    buttonText={[`Save`, `Don't Save`, `Cancel`]}
                    onCloseWithoutSaving={onCloseWithoutSaving}
                />
            )}

            {isRequiredFieldsNotFilled && (
                <SimpleConfirmPopup
                    onClose={setIsRequiredFieldsNotFilled}
                    contentText={`Required fields are not filled or have illegal values (email/url).
Please fill in or change them and try saving again.`}
                    onConfirm={confirmErrorPopup}
                    buttonText={[`OK`]}
                />
            )}


        </>
    );
};
